// SetUsernameModal.jsx
import React, { useState } from 'react';
import { updateProfile, updatePassword } from 'firebase/auth';
import { auth, db } from '../../firebase';
import { collection, query, where, getDocs, doc, setDoc } from 'firebase/firestore';
import './SetUsernameModal.css';

const SetUsernameModal = ({ onClose }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username.trim() || !password.trim()) {
      setError('Username and password cannot be empty.');
      return;
    }

    try {
      // Check if username already exists
      const usersRef = collection(db, 'users');
      const q = query(usersRef, where('username', '==', username));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        setError('Username already exists. Please choose another.');
        return;
      }

      // Update Firebase Auth profile
      await updateProfile(auth.currentUser, { displayName: username });
      await updatePassword(auth.currentUser, password);

      // Create/update Firestore user document
      const userDocRef = doc(db, 'users', auth.currentUser.uid);
      await setDoc(userDocRef, {
        username,
        email: auth.currentUser.email,
        updatedAt: new Date()
      }, { merge: true });

      onClose(); // Close the modal after successful update
    } catch (err) {
      console.error('Error setting username/password:', err);
      setError(err.message);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2>Complete Your Profile</h2>
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="username">Username:</label>
            <input
              id="username"
              name="username"
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">New Password:</label>
            <input
              id="password"
              name="password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="submit-button">Save & Continue</button>
        </form>
      </div>
    </div>
  );
};

export default SetUsernameModal;
